import {
  ResponseEnum,
  type ActivityAvailability,
} from "@b2bportal/rbc-activities-api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import type { ActivitiesState } from "../../../../store";
import type { ActivitySearchDetails } from "../types";
import { fetchActivitiesAvailability } from "./api/fetchActivitiesAvailability";

/**
 * Async thunk for fetching activities based on search details
 */
export const fetchActivities = createAsyncThunk<
  {
    activities: Array<ActivityAvailability>;
    nextPageToken: string | null;
    searchId: string;
  },
  ActivitySearchDetails,
  { state: ActivitiesState; rejectValue: { error: string } }
>("activitiesAvailability/fetchActivities", async (searchDetails, thunkAPI) => {
  try {
    const response = await fetchActivitiesAvailability(searchDetails);

    if (response.Response === ResponseEnum.Failure) {
      return thunkAPI.rejectWithValue({
        error:
          response.errors[0].details ??
          "An error occurred while fetching activities",
      });
    }

    return {
      activities: response.value?.activities,
      nextPageToken: response.value?.nextPageToken?.token ?? null,
      searchId: response.value?.encodedTags ?? "",
      categoryTags: response.value?.categoryTags ?? [],
      popularFeatureTags: response.value?.popularFeatureTags ?? [],
    };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : String(error);
    return thunkAPI.rejectWithValue({ error: errorMessage });
  }
});
